import { QRCode } from "react-qr-code";

// Level "H" tolerates ~30% damage; the logo covers about 4% of the code's area.
const BrandedQRCode = ({ value, size }) => {
  const logo = Math.round(size * 0.22);
  return (
    <div className="relative inline-block leading-none" style={{ width: size, height: size }}>
      <QRCode value={value} size={size} level="H" bgColor="#ffffff" fgColor="#000000" />
      <img
        src="/nameit-icon-512.png"
        alt=""
        width={logo}
        height={logo}
        className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 rounded-lg bg-white p-1 shadow-sm"
      />
    </div>
  );
};

export default BrandedQRCode;
